module.exports = __webpack_public_path__ + "static/media/icon_bq_cd_06sousuo.8a26a3b4.svg";